import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const useStyles = makeStyles({
   // Compact typography so a rendered answer reads well inside a table cell or
   // the edit-dialog preview pane.
   root: {
      fontSize: 14,
      lineHeight: 1.5,
      wordBreak: 'break-word',
      '& :first-child': { marginTop: 0 },
      '& :last-child': { marginBottom: 0 },
      '& p': { margin: '0 0 8px' },
      '& ul, & ol': { margin: '0 0 8px', paddingLeft: 20 },
      '& li': { margin: '2px 0' },
      '& h1, & h2, & h3, & h4, & h5, & h6': { margin: '12px 0 4px', lineHeight: 1.3 },
      '& h1': { fontSize: 18 },
      '& h2': { fontSize: 16 },
      '& h3, & h4, & h5, & h6': { fontSize: 14 },
      '& a': { color: '#1E528F' },
      '& code': {
         backgroundColor: '#F0F0F0',
         borderRadius: 3,
         padding: '1px 4px',
         fontSize: '0.9em',
      },
      '& pre': {
         backgroundColor: '#F0F0F0',
         borderRadius: 4,
         padding: 8,
         overflowX: 'auto',
      },
      '& blockquote': {
         margin: '0 0 8px',
         paddingLeft: 12,
         borderLeft: '3px solid #E0E0E0',
         color: '#555',
      },
      '& table': { borderCollapse: 'collapse' },
      '& th, & td': { border: '1px solid #E0E0E0', padding: '4px 8px' },
   },
});

/**
 * Renders a Markdown string (GitHub-flavoured, single newlines become line breaks).
 * Raw HTML in the source is NOT parsed - rehype-raw is deliberately not used - so
 * embedded markup is shown as literal text and cannot inject scripts.
 */
export default function Markdown({ children }) {
   const classes = useStyles();

   return (
      <div className={classes.root}>
         <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkBreaks]}
            linkTarget={'_blank'}
         >
            {children || ''}
         </ReactMarkdown>
      </div>
   );
}

Markdown.propTypes = {
   children: PropTypes.string,
};
